import {ComponentProps} from "@/props.ts";
import {IProtocol, isProtocol, TProtocolId} from "../types/protocol";
import React, {useEffect, useState} from "react";
import {SubjectProtocolSelection} from "../SubjectProtocolSelection";
import {useNeurotuneStore} from "@/common/store/neurotune";
import {useProtocolStore} from "../store/protocols";
import {useProtocolDefinitionsStore} from "../store/protocolDefinitions";
import * as protocolServices from "../services/protocols"
import {IProtocolDefinition} from "../types/protocolDefinitions";
import {TSubjectId} from "@/common/types";
import {useNavigate} from "react-router";

interface PatientVisitPageProps extends ComponentProps {
}

const PatientVisitPage: React.FC<PatientVisitPageProps> = ({}: PatientVisitPageProps) => {
    const reset = useProtocolStore().reset
    const navigate = useNavigate()
    const activeCompany = useNeurotuneStore((state) => state.activeCompany)
    const [selectedProtocolId, _setSelectedProtocolId] = useState<TProtocolId>()
    const loadProtocolDefinitions = useProtocolDefinitionsStore((state) => state.loadProtocolDefinitions)
    const addProtocol = useProtocolStore((state) => state.addProtocol)

    useEffect(() => {
        // when a protocol is selected we clear the store to avoid stale cash issues
        reset()
        console.log("PatientVisitPage: reset protocol store")
    }, [selectedProtocolId])

    useEffect(() => {
        loadProtocolDefinitions(activeCompany.id)
    }, [activeCompany])


    const onProtocolSelection = async (subjectId: TSubjectId, protocol: IProtocol | IProtocolDefinition, sessionName: string | null) => {

        if (isProtocol(protocol)) {
            navigate(`/sessions/visit/${subjectId}/${protocol.id}`)
        } else {
            // we first need to create an instance of the protocol
            protocolServices.createProtocol(activeCompany.id, subjectId, protocol.id).then(async (rprotocol) => {
                if (sessionName) {
                    rprotocol = await protocolServices.updateProtocol(activeCompany.id, {
                        ...rprotocol,
                        name: sessionName
                    })
                }
                addProtocol(activeCompany.id, rprotocol)
                navigate(`/sessions/visit/${subjectId}/${rprotocol.id}`)
            })
        }
    }

    return <SubjectProtocolSelection onProtocolSelection={onProtocolSelection}/>
}

export {PatientVisitPage}